import React from 'react';
const ProgramModules = () => {
  return <div className="my-16">
      <div className="text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-serif font-light text-sage-800 mb-4">The Group Coaching Curriculum</h2>
        <p className="text-xl text-gray-700 max-w-3xl mx-auto">
          A comprehensive, trauma-informed journey through three transformative paths
        </p>
      </div>

      {/* Path One Accordion */}
      <details className="group mb-6 bg-white rounded-2xl border-2 border-sage-200 shadow-lg overflow-hidden">
        <summary className="cursor-pointer p-6 md:p-8 hover:bg-sage-50 transition-all duration-300 flex justify-between items-center list-none">
          <div>
            <h3 className="text-2xl md:text-3xl font-serif font-light text-sage-800 mb-2">Path One: Coming Home to Yourself</h3>
            <p className="text-lg text-warm-700 font-medium">Foundations of Safety, Awareness, and Self-Connection</p>
          </div>
          <svg className="w-8 h-8 text-sage-600 group-open:rotate-180 transition-transform duration-300 flex-shrink-0 ml-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </summary>
        <div className="p-6 md:p-8 pt-4 bg-gradient-to-br from-sage-50 to-cream-50">
          <div className="mb-6">
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4">
              Healing begins with safety. In this first path, you'll practice attuning to your body's wisdom and understand your people-pleasing and fawning patterns through compassion, not harshness.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
              You'll explore how stress and trauma live in your body, how social conditioning shaped your self-concept, and how to gently regulate your system so calm becomes a familiar state you can access with greater ease.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h5 className="text-xl font-semibold text-sage-800 mb-4 flex items-center">
                <svg className="w-6 h-6 text-warm-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                You'll Learn To:
              </h5>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Listen to your body's cues and respond with care</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Recognize how trauma and gender roles shape your behavior</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Build a foundation of nervous-system safety</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Interrupt old patterns with self-compassion and curiosity</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h5 className="text-xl font-semibold text-sage-800 mb-4 flex items-center">
                <svg className="w-6 h-6 text-warm-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                  <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                </svg>
                12 Modules:
              </h5>
              <div className="space-y-2">
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">1. Orientation: Intention, Attention, Energy, and Power</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">2. People-pleasing Deep Dive</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">3. Grounded Body: My Window of Tolerance</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">4. Stress in Our Bodies and Stress Responses</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">5. Listening to My Body</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">6. Feelings and Needs</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">7. Root Cause: Complex Trauma</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">8. Root Cause: Gender Role Socialization</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">9. Inner Critic: Shame and Guilt</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">10. Nervous System Regulation</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">11. Breaking the Patterns</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">12. My HopefulPath Plan</div>
              </div>
            </div>
          </div>
          
          <p className="text-base md:text-lg text-gray-700 leading-relaxed italic mt-6 text-center p-4 bg-white rounded-lg">
            By the end of Path One, you'll feel more grounded, centered, and connected to your inner world — ready to meet yourself with curiosity and care.
          </p>
        </div>
      </details>

      {/* Path Two Accordion */}
      <details className="group mb-6 bg-white rounded-2xl border-2 border-sage-200 shadow-lg overflow-hidden">
        <summary className="cursor-pointer p-6 md:p-8 hover:bg-sage-50 transition-all duration-300 flex justify-between items-center list-none">
          <div>
            <h3 className="text-2xl md:text-3xl font-serif font-light text-sage-800 mb-2">Path Two: Boundaries, Anger, and Authentic Expression</h3>
            <p className="text-lg text-warm-700 font-medium">Reclaiming Power, Presence, and Emotional Truth</p>
          </div>
          <svg className="w-8 h-8 text-sage-600 group-open:rotate-180 transition-transform duration-300 flex-shrink-0 ml-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </summary>
        <div className="p-6 md:p-8 pt-4 bg-gradient-to-br from-sage-50 to-cream-50">
          <div className="mb-6">
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4">
              Once safety is established, it's time to rediscover your voice. Path Two invites you to use your anger and boundaries as sacred allies — guides that lead you back to authenticity and self-respect.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
              You'll learn to express emotions safely, communicate clearly, and stand firm in your truth while staying connected to others. You'll transform patterns of suppression into empowerment and use your body as a compass for truth.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h5 className="text-xl font-semibold text-sage-800 mb-4 flex items-center">
                <svg className="w-6 h-6 text-warm-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                You'll Learn To:
              </h5>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Set and hold boundaries that honor you and others</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Understand anger as a messenger, not a mistake</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Express emotions without shame or fear</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Communicate needs with clarity and compassion</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h5 className="text-xl font-semibold text-sage-800 mb-4 flex items-center">
                <svg className="w-6 h-6 text-warm-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                  <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                </svg>
                12 Modules:
              </h5>
              <div className="space-y-2">
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">1. Orientation: Intention, Attention, Energy, and Power</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">2. Purpose of Anger</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">3. Listening to My Body</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">4. Anger & Identity</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">5. Inner critic: Shame and Guilt</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">6. My Communication Style: Respect, aggression and explosive anger</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">7. My space: Non-verbal Boundaries</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">8. Articulating Boundaries</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">9. Boundary Scripts and Practice</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">10. Self and Other Validation: Kindness and Fawn</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">11. Embodying Our Anger</div>
                
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">12. My HopefulPath Plan</div>
              </div>
            </div>
          </div>
          
          <p className="text-base md:text-lg text-gray-700 leading-relaxed italic mt-6 text-center p-4 bg-white rounded-lg">
            By the end of Path Two, you'll know how to meet anger with compassion, speak your truth with confidence, and build relationships grounded in mutual respect and emotional safety.
          </p>
        </div>
      </details>

      {/* Path Three Accordion */}
      <details className="group mb-6 bg-white rounded-2xl border-2 border-sage-200 shadow-lg overflow-hidden">
        <summary className="cursor-pointer p-6 md:p-8 hover:bg-sage-50 transition-all duration-300 flex justify-between items-center list-none">
          <div>
            <h3 className="text-2xl md:text-3xl font-serif font-light text-sage-800 mb-2">Path Three: Integration, Wholeness, and Authentic Connection</h3>
            <p className="text-lg text-warm-700 font-medium">Loving, Leading, and Living from a place of Wholeness</p>
          </div>
          <svg className="w-8 h-8 text-sage-600 group-open:rotate-180 transition-transform duration-300 flex-shrink-0 ml-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </summary>
        <div className="p-6 md:p-8 pt-4 bg-gradient-to-br from-sage-50 to-cream-50">
          <div className="mb-6">
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4">
              In this final path, you'll integrate everything you've learned into daily life — moving from insight to embodiment. You'll explore vulnerability, intimacy, and forgiveness, learning how to stay connected to yourself while staying close to others.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
              This is where healing ripples outward: your relationships soften, your self-trust deepens, and your life begins to feel like yours.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h5 className="text-xl font-semibold text-sage-800 mb-4 flex items-center">
                <svg className="w-6 h-6 text-warm-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                You'll Learn To:
              </h5>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Release shame, guilt, and old resentments</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Cultivate intimacy without losing yourself</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Integrate your soft and strong energies</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-600 mr-2">•</span>
                  <span>Live and lead from an embodied, authentic self</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h5 className="text-xl font-semibold text-sage-800 mb-4 flex items-center">
                <svg className="w-6 h-6 text-warm-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                  <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                </svg>
                12 Modules:
              </h5>
              <div className="space-y-2">
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">1. Orientation: Intention, Attention, Energy, and Power</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">2. Listening to My Body: Anger, Rage, and Grief</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">3. Updating Self-Abandoning Part</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">4. Updating Pleasing Parts</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">5. Updating Inner Critic: Shame and Guilt</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">6. Stopping Emotional and Spiritual Bypass</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">7. Relational Intelligence</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">8. Belonging</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">9. In-to-me-see: Merging and Vulnerability</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">10. Pleasure, Passion, and Sex</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">11. Leading and Following</div>
                <div className="bg-white rounded-lg border border-sage-200 shadow-sm p-3">12. My HopefulPath Plan</div>
              </div>
            </div>
          </div>
          
          <p className="text-base md:text-lg text-gray-700 leading-relaxed italic mt-6 text-center p-4 bg-white rounded-lg">
            By the end of Path Three, you'll embody wholeness — grounded, expressive, and connected to your truth.
          </p>
        </div>
      </details>
    </div>;
};
export default ProgramModules;